import { z } from 'zod'

import { segmentsSlice, updateCounter } from 'common/filter/reducers/segments'
import { SegmentSchema } from 'shared/api/requests/audience/schemas'
import { accountNotificationsListener } from 'utils/services/notificationsService'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const segmentsActions = {
  ...segmentsSlice.actions,
  updateCounter,
}

const SegmentUpdatedSchema = SocketEventBaseSchema.extend({
  event: z.literal('segment_updated'),
  id: z.string().optional(),
  model: SegmentSchema,
})
accountNotificationsListener.on(SegmentUpdatedSchema, (data, dispatch) => {
  dispatch(
    segmentsActions.updateItem({
      id: data.model.segment_id,
      data: data.model,
      rewrite: true,
    }),
  )
})

const UpdateCounterEvent = SocketEventBaseSchema.extend({
  event: z.literal('segment_counter_updated'),
  id: z.string(),
  delta: z.number(),
})
accountNotificationsListener.on(UpdateCounterEvent, (data, dispatch) => {
  dispatch(segmentsActions.updateCounter(data))
})

const SegmentDeletedEvent = SocketEventBaseSchema.extend({
  event: z.literal('segment_deleted'),
  id: z.string().optional(),
})
accountNotificationsListener.on(SegmentDeletedEvent, (data, dispatch) => {
  if (data.id) {
    dispatch(segmentsActions.deleteItem({ id: data.id }))
  }
})

const SegmentCreatedEvent = SocketEventBaseSchema.extend({
  event: z.literal('segment_created'),
  model: SegmentSchema,
})
accountNotificationsListener.on(SegmentCreatedEvent, (data, dispatch) => {
  dispatch(segmentsActions.appendItem({ item: data.model }))
})
